import { FormRows } from '@acorns/web-components'
import { pathOr } from 'ramda'
import { object, string } from 'yup'

import { USER_TYPE } from 'app-constants'
import { canPrePopulate } from 'utils/date/validate'
import { ssnMask } from 'utils/text-masks/ssn'
import { noSpecialCharacters } from 'utils/validation-schemas/helpers'

const DISABLED_SSN_USER_TYPE = 'qatest'
const VALID_SSN_REGEX = /^(?!(000|666))\d{3}-(?!00)\d{2}-(?!0000)\d{4}$/
const SSN_REGEX = /^\d{3}-\d{2}-\d{4}$/

/**
 * Retrieves SSN digit regex if validation is disabled and user is a test user. Otherwise, return validation regex.
 */
const getRegex = (isValidationDisabled: boolean) => {
  const userType = window.sessionStorage.getItem(USER_TYPE)
  return isValidationDisabled && userType === DISABLED_SSN_USER_TYPE ? SSN_REGEX : VALID_SSN_REGEX
}

export default [
  [
    {
      label: 'Social Security Number *',
      name: 'ssn',
      mask: ssnMask,
      placeholder: 'XXX-XX-XXXX',
      type: 'text',
      guide: false,
      helperText:
        'The U.S. government requires your SSN in order to open an investment account. All your information is protected by 256-bit encryption and bank-level security.',
    },
  ],
] as FormRows

export const getSchema = (isValidationDisabled: boolean) => {
  const regex = getRegex(isValidationDisabled)
  return object({
    ssn: string()
      .required('Please enter a valid social security number.')
      .matches(regex, 'Please enter a valid social security number'),
  })
}

noSpecialCharacters()

export const mapPropsToValues = () => ({ data }) => {
  const can = canPrePopulate(pathOr(null, ['profile', 'createdAt'], data))
  const source = data.user || {}

  const values: any = (({ ssn }) => ({
    ssn: (can && ssn) || '',
  }))(source)

  return values
}
